<template>
    <div class="image-box" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="image">
        <img ref="imageContainer" :src="ImagePath" @load="handlePortraitLoad" @click="showBigImage()" />
      </div>
    </div>
</template>

<script>
  export default {
    name: 'imagecomponent',
    props: {
      ArticleId: String,
      SerialNo: String,
      ImagePath: String,
      Index: String
    },
    data() {
      return {
        fullscreenLoading: false,
      };
    },
    methods: {
      handlePortraitLoad() {
        if (this.Index == "0") {
          this.$refs.imageContainer.style.marginTop = `30px`;
        }
      },
      showBigImage (){
        if (this.fullscreenLoading) {
          return
        }
        this.fullscreenLoading = true

        var inputParam = {
          article_id: this.ArticleId,
          serial_no: this.SerialNo
        }
        this.$store.dispatch('communication0007/getSCArticleBigImage', inputParam).then(() => {
          this.fullscreenLoading = false;
        })
      },
    },
    mounted() {
      this.$refs.imageContainer.addEventListener('load', this.handlePortraitLoad);
    },
    beforeDestroy() {
      this.$refs.imageContainer.removeEventListener('load', this.handlePortraitLoad);
    }
  };
</script>

<style scoped>
.image-box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  float: left;
  clear: both;
  max-width: 300px;
  margin-right: 10px;
}
.image-box .image img {
  width: 300px;
  height: auto;
  margin-bottom: 5px;
  cursor: pointer;
}
</style>